export { default } from './get-environment-variable';
